import React, { Component, PropTypes } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import BraintreeFormModal from 'common/components/modal/braintree_form_modal';

/**
 * Client's payment method, with the ability to add a new one if there's none
 * or replace the existing one if it's the case.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class PaymentMethod extends Component {
  constructor(props) {
    super(props)

    this.state = {showingModal: false}
    this.showFormModal = this.showFormModal.bind(this)
  }

  showFormModal() {
    this.setState({showingModal: true})
  }

  componentDidMount() {
    this.props.fetchMethodIfNeeded()
  }

  render() {
    const { method } = this.props
    const { showingModal } = this.state

    if (method === undefined) return <LoadingIndicator fullScreen={false}/>

    return (
      <div className="payment-method">

        {method?
        <div className="form-group">
          <label className="method-label">{method.type == "PayPal"? "PayPal":"Credit Card"}</label>

          <div className="row">
            <div className="columns small-4 large-3">
              <img src={method.image}/>
            </div>

            <div className="columns small-12 medium-8 large-9">
              <div className="payment-method-details">
                {method.last4 ? `ending in -${method.last4}` : method.email}
              </div>
            </div>

            <div className="columns small-16 medium-4">
              <div className="payment-method-actions">
                <button className="btn btn-secondary btn-sm" onClick={this.showFormModal}>
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>:
        <button className="btn btn-secondary" onClick={this.showFormModal}>
          Add
        </button>}

        <BraintreeFormModal showing={showingModal}
          onClose={() => this.setState({showingModal: false})}/>

      </div>)
  }
}

PaymentMethod.propTypes = {
  fetchMethodIfNeeded: PropTypes.func,
  method: PropTypes.object,
};



// WEBPACK FOOTER //
// ./common/components/payment_method.jsx